import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const IconPlus: FunctionComponent<Props> = ({
  className = "",
  width = "29",
  height = "30",
  fill = "currentColor",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 29 30"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Expand</title>
      <line
        x1="4"
        y1="14.4805"
        x2="26"
        y2="14.4805"
        stroke={fill}
        strokeWidth="4"
      />
      <line
        x1="15"
        y1="3.48047"
        x2="15"
        y2="25.4805"
        stroke={fill}
        strokeWidth="4"
      />
    </svg>
  );
};

export default IconPlus;
